import { render } from "./ChangeName.vue?vue&type=template&id=4b40c05f"
import script from "./ChangeName.vue?vue&type=script&lang=js"
export * from "./ChangeName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Settings/Account/ChangeName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b40c05f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b40c05f', __exports__)) {
    api.reload('4b40c05f', __exports__)
  }
  
  module.hot.accept("./ChangeName.vue?vue&type=template&id=4b40c05f", () => {
    api.rerender('4b40c05f', render)
  })

}


export default __exports__